import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subscription, interval, from } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Radio } from 'src/app/models/radio';
import * as firebase from 'firebase';
import { RadioService } from 'src/app/services/radio.service';
import { RadiosDataService } from 'src/app/services/radios-data.service';
import { map } from 'rxjs/operators';
import { Program } from 'src/app/models/program';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


export interface PeriodicElement {
  video: string;
  position: number;
  description: string;
  title: string;
  date: string

}
const ELEMENT_DATA: PeriodicElement[] = [
  { video: "https://www.youtube.com/embed/rvydkPjlM0E", position: 1, description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi veritatis dignissimos aperiam quas id repellat, nihil quod earum! Et facere, quisquam architecto aliquid iusto quo rem voluptas. Molestiae, eaque modi!", title: "EXMAPLE TITLE", date: new Date().getDate().toString() },
  { video: "https://www.youtube.com/embed/rvydkPjlM0E", position: 1, description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi veritatis dignissimos aperiam quas id repellat, nihil quod earum! Et facere, quisquam architecto aliquid iusto quo rem voluptas. Molestiae, eaque modi!", title: "EXMAPLE TITLE", date: new Date().getDate().toString() },
  { video: "https://www.youtube.com/embed/rvydkPjlM0E", position: 1, description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi veritatis dignissimos aperiam quas id repellat, nihil quod earum! Et facere, quisquam architecto aliquid iusto quo rem voluptas. Molestiae, eaque modi!", title: "EXMAPLE TITLE", date: new Date().getDate().toString() },
  { video: "https://www.youtube.com/embed/rvydkPjlM0E", position: 1, description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi veritatis dignissimos aperiam quas id repellat, nihil quod earum! Et facere, quisquam architecto aliquid iusto quo rem voluptas. Molestiae, eaque modi!", title: "EXMAPLE TITLE", date: new Date().getDate().toString() },
  { video: "https://www.youtube.com/embed/rvydkPjlM0E", position: 1, description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi veritatis dignissimos aperiam quas id repellat, nihil quod earum! Et facere, quisquam architecto aliquid iusto quo rem voluptas. Molestiae, eaque modi!", title: "EXMAPLE TITLE", date: new Date().getDate().toString() },
  { video: "https://www.youtube.com/embed/rvydkPjlM0E", position: 1, description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi veritatis dignissimos aperiam quas id repellat, nihil quod earum! Et facere, quisquam architecto aliquid iusto quo rem voluptas. Molestiae, eaque modi!", title: "EXMAPLE TITLE", date: new Date().getDate().toString() },
];
@Component({
  selector: 'app-envivo-new',
  templateUrl: './envivo-new.component.html',
  styleUrls: ['./envivo-new.component.scss']
})
export class EnvivoNewComponent implements OnInit {
  displayedColumns: string[] = ['video'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  dataSourceElements: PeriodicElement;


  zoom = 17;
  center = {
    lat: -17.390485,
    lng: -66.1618321,
  };
  options: google.maps.MapOptions = {
    disableDoubleClickZoom: true,
  };
  videos: any[];
  @Input() public src: string;
  @Input() public autoplay: boolean = false;
  @Input() public showStateLabel: boolean = false;
  public audioStateLabel = 'Audio sample';
  @Input() public volume: number = 1.0; /* 1.0 is loudest */

  @ViewChild('audioElement', { static: false }) public _audioRef: ElementRef;
  @ViewChild('audioElement2', { static: false }) public _audioRef2: ElementRef;
  @ViewChild('audioElement3', { static: false }) public _audioRef3: ElementRef;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  private audio: HTMLMediaElement;
  private audio2: HTMLMediaElement;
  private audio3: HTMLMediaElement;

  fotoelegida;
  radiosPlaying: Radio[];
  actualPlaynig: Radio = null;
  dateactuall: Date;
  Subscription: Subscription = new Subscription();
  radioProgram: Program;
  title = 'animaciones';
  contador = 10;


  YTvideos = [
    { id: "1", video: "https://www.youtube.com/embed/lFlkYz7szZw" },
    { id: "2", video: "https://www.youtube.com/embed/Uqd9fYkhyJ0" },
    { id: "3", video: "https://www.youtube.com/embed/WXWlH6Na4Wo" },
  ];
  safeSrc: SafeResourceUrl;

  fotos = [
    { id: "1", img: "data:image/jpeg;base64,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" },
    { id: "2", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTajjPTlzxIHV2dClhdWzdb4E3dFfuQpxcpDzBQltkzmNUc-SgJ&usqp=CAU" },
    { id: "3", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTy4OWkh7wLCLZFRPJXINP5PhLU9BuwkDoZ1s40aVeLvZWZCVKp&usqp=CAU" },
    { id: "4", img: "https://img.europapress.es/fotoweb/fotonoticia_20140809163929_420.webp" },
    { id: "5", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcStOsDjuzsoBZ1jwAXZ0IF2FdINcOwdXwrOw1tJFORrmktqLdUM&usqp=CAU" },
    { id: "6", img: "https://cde.peru.com//ima/0/1/5/1/2/1512528/611x458/daniel-radcliffe.jpg" },
    { id: "7", img: "https://st-listas.20minutos.es/images/2014-10/388315/list_640px.jpg?1496241599" },
    { id: "8", img: "https://gestion.pe/resizer/Ps71g5L6VmavdrYxng9p8uzLB-4=/980x528/smart/arc-anglerfish-arc2-prod-elcomercio.s3.amazonaws.com/public/MTAKNCOMFBFB5ND7G7SMSBOKHU.jpg" },
  ];


  contafoto = 0;

  fotoElegida = this.fotos[this.contafoto];

  anterior() {
    if (this.contafoto > 0) {
      this.contafoto--;
      this.fotoElegida = this.fotos[this.contafoto];
    }
  }

  siguiente() {
    if (this.contafoto < 7) {
      this.contafoto++;
      this.fotoElegida = this.fotos[this.contafoto];
    }
  }


  izquierda() {
    this.contador--;
    if (this.contador == 0) {
      this.contador += 3;
    }
    this.cambiarVideo(this.contasum(0));
  }
  derecha() {
    this.contador++;
    this.cambiarVideo(this.contasum(0));
  }

  contasum(num) {
    if ((this.contador % 3 + num) > 2) {
      return (this.contador % 3 + num - 3);
    }

    else {
      return (this.contador % 3 + num);
    }
  }

  constructor(
    public sanitizer: DomSanitizer,
    public router: Router,
    private radioServ: RadioService,
    public serviceRadio: RadiosDataService,

  ) {
    this.dateactuall = firebase.firestore.Timestamp.now().toDate();
  }
  ngOnDestroy(): void {
    this.Subscription.unsubscribe();
  }
  subscriber: Subscription = new Subscription();

  cambiarVideo(id) {
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.YTvideos[id].video);
  }

  ngOnInit() {
    this.pause();
    this.pause2();
    this.pause3();

    this.videos = [];

    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.YTvideos[0].video);
    this.dataSource.paginator = this.paginator;
    this.Subscription.add(
      this.serviceRadio.getPlayer().subscribe((radio) => {
        this.radioServ.getVisible().then(radios =>{
          this.radiosPlaying = radios;
          if (this.radiosPlaying) {
            this.actualPlaynig = this.radiosPlaying[radio];
          }
        })
      })
    );
    this.Subscription.add(interval(1000)
      .pipe(
        map((tick) => {
          this.dateactuall = new Date(
            this.dateactuall.setSeconds(this.dateactuall.getSeconds() + 1)
          );
          this.setProgram(this.dateactuall);

          return tick;
        })
      )
      .subscribe());
  }


  setProgram(time: Date) {
    let hour = time.getHours();
    let minutes = time.getMinutes();
    let day = time.getDay();
    if (this.actualPlaynig) {
      switch (day) {
        case 0: this.setProgramDay(hour, minutes, this.actualPlaynig.sunday);
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 5: this.setProgramDay(hour, minutes, this.actualPlaynig.programLV);
          break;
        case 6: this.setProgramDay(hour, minutes, this.actualPlaynig.saturday);
          break;
        default:
          break;
      }
    }

  }

  setProgramDay(hour: number, minutes: number, programs: Program[]) {
    let selected: Program;
    programs.forEach(prog => {
      if (this.compare(prog.starttime, hour, minutes) && !this.compare(prog.endtime, hour, minutes)) {
        selected = prog;
      }
    });
    this.radioProgram = selected;
  }
  compare(time: NgbTimeStruct, hour: number, minute: number) {
    let hourtime = time.hour
    let minutetime = time.minute;

    minutetime += hourtime * 60;
    minute += hour * 60;

    return minute >= minutetime;

  }

  ngAfterContentInit() {
    window.scroll(0, 0);
  }

  convertToLocalDate(date) {
    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
  }

  showTableVideos() {
    let table = document.getElementById('contenedorTablaVideos');
    table.style.display = "block";
    document.getElementById('btnlivevideos').style.display = "none";
    document.getElementById('imgultimo').style.display = "none";
    document.getElementById('descripcion-ultimo').style.display = "none";
  }
  hideTableVideos() {
    let table = document.getElementById('contenedorTablaVideos');
    table.style.display = "none";
    document.getElementById('btnlivevideos').style.display = "block"
    document.getElementById('imgultimo').style.display = "block";
    document.getElementById('descripcion-ultimo').style.display = "block";
  }

  public pause(): void {
    if (this.audio) {
      this.audio.pause();
      this.audioStateLabel = 'Paused';
    }
  }

  public get paused(): boolean {
    if (this.audio) {
      return this.audio.paused;
    } else {
      return true;
    }
  }

  public play(): void {
    if (this.audio3) {
      this.audio3.pause();
      this.audioStateLabel = 'Paused';
    }
    if (this.audio2) {
      this.audio2.pause();
      this.audioStateLabel = 'Paused';
    }
    if (this.audio) {
      if (this.audio.readyState >= 2) {
        this.audio.play();
        this.audioStateLabel = 'Playing...';
      }
    }
  }

  public pause2(): void {
    if (this.audio2) {
      this.audio2.pause();
      this.audioStateLabel = 'Paused';
    }
  }

  public get paused2(): boolean {
    if (this.audio2) {
      return this.audio2.paused;
    } else {
      return true;
    }
  }

  public play2(): void {
    if (this.audio3) {
      this.audio3.pause();
      this.audioStateLabel = 'Paused';
    }
    if (this.audio) {
      this.audio.pause();
      this.audioStateLabel = 'Paused';
    }
    if (this.audio2) {
      if (this.audio2.readyState >= 2) {
        this.audio2.play();
        this.audioStateLabel = 'Playing...';
      }
    }
  }

  public pause3(): void {
    if (this.audio3) {
      this.audio3.pause();
      this.audioStateLabel = 'Paused';
    }
  }

  public get paused3(): boolean {
    if (this.audio3) {
      return this.audio3.paused;
    } else {
      return true;
    }
  }

  public play3(): void {
    if (this.audio) {
      this.audio.pause();
      this.audioStateLabel = 'Paused';
    }
    if (this.audio2) {
      this.audio2.pause();
      this.audioStateLabel = 'Paused';
    }
    if (this.audio3) {
      if (this.audio3.readyState >= 2) {
        this.audio3.play();
        this.audioStateLabel = 'Playing...';
      }
    }
  }

  public ngAfterViewInit() {
    if (this._audioRef && this._audioRef2 && this._audioRef3) {
      this.audio = this._audioRef.nativeElement;
      this.audio2 = this._audioRef2.nativeElement;
      this.audio3 = this._audioRef3.nativeElement;
      if (this.audio) {
        this.audio.volume = this.volume;
        this.audio.autoplay = this.autoplay;
      }
      if (this.audio2) {
        this.audio2.volume = this.volume;
        this.audio2.autoplay = this.autoplay;
      }
      if (this.audio3) {
        this.audio3.volume = this.volume;
        this.audio3.autoplay = this.autoplay;
      }
    }
  }
}
